<template>
  <div class="mall-spend">
    <div class="page-section" style="border-top: none">
      <el-form class="page-search__form" ref="searchForm" :model="listInfo">
        <div class="page-search__item">
          <el-form-item>
            <el-select
              :placeholder="$t('financial.coupon.orderType')"
              clearable
              filterable
              v-model="listInfo.type"
            >
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in mallExpenditureTypeDict"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__item page-search__item_flex">
          <el-button
            type="primary"
            class="page-button_medium"
            @click="getMallFinancialData()"
            >{{ $t('common.search') }}</el-button
          >
          <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </div>
      </el-form>
    </div>
    <div class="page-section">
      <div class="page-table" v-if="tableHeight > 0">
        <el-table
          :data="listData"
          :max-height="tableHeight + 'px'"
          v-loading="listLoading"
          :element-loading-text="$t('common.loading')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column :label="$t('common.type')" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ getTypeName(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            :label="$t('common.time')"
            min-width="120px"
            :formatter="formatToEmpty"
          >
            <template slot-scope="{ row }">
              <span>{{ row.gmtCreate.split(' ')[0] }}</span>
              <br />
              <span>{{ row.gmtCreate.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('common.amountWithYuan')"
            min-width="120px"
            :formatter="formatToYuan"
          ></el-table-column>
          <el-table-column
            prop="balance"
            :label="$t('common.balanceWithYuan')"
            min-width="120px"
            :formatter="formatToYuan"
          ></el-table-column>
          <el-table-column :label="$t('common.orderNo')" min-width="180px">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.orderNo"
                type="text"
                @click="goToOrderDetailPage(row)"
                >{{ row.orderNo }}</el-button
              >
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operatorName"
            :label="$t('common.operator')"
            min-width="120px"
            :formatter="formatToEmpty"
          ></el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('common.remark')"
            min-width="180px"
            :formatter="formatToEmpty"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="page-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getMallFinancialData"
          :current-page="listInfo.pageNum"
          :page-size="listInfo.pageSize"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import * as toolApi from '@/apis/tool'
import * as financialApi from '@/apis/financial'
import { formatToYuan, formatToEmpty, formatToLabel } from '@/utils/formatters'
import { getBaseURL, getWebURL } from '@/utils/util'
import { mallExpenditureTypeDict } from '@/data/dicts'
import { translateByDict } from '@/utils/translators'
export default {
  name: 'mallExpenditure',
  props: {
    tableHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formatToYuan,
      formatToEmpty,
      formatToLabel,
      mallExpenditureTypeDict,
      listInfo: {
        recordType: 2,
        type: '',
        productType: '',
        serviceType: '',
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      },
      listData: [],
      listLoading: false,
      downloadLoading: false,
    }
  },
  activated() {
    this.getMallFinancialData()
  },
  methods: {
    async getMallFinancialData(pageNum = 1) {
      this.listLoading = true
      try {
        this.listInfo.pageNum = pageNum

        const params = _.cloneDeep(this.listInfo)
        if (params.type || params.type === 0) {
          const [productType, ...type] = String(params.type).split('')
          params.productType = productType
          if (productType === '1' || productType === '3') {
            params.bizType = ''
            params.serviceType = params.type
          } else {
            params.bizType = ''
            params.serviceType = ''
          }
          params.type = ''
        }

        const result = await financialApi.getMallFinancialData(params)
        this.listLoading = false

        if (result) {
          const { records, pageNum, totalCount } = result
          this.listData = records || []
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          }
        }
      } catch (err) {
        this.listLoading = false
        throw new Error(err)
      }
    },
    resetSearch() {
      this.listInfo = {
        recordType: 2,
        type: '',
        productType: '',
        serviceType: '',
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
      }
      this.$refs.searchForm.clearValidate()
      this.getMallFinancialData()
    },
    async goToOrderDetailPage({ orderNo, productType }) {
      let url = ''
      switch (productType) {
        case 1:
          url =
            getWebURL('platform') +
            '/web/mall?path=/airport-service/order/detail/' +
            orderNo
          break
        case 2:
          url =
            getWebURL('platform') +
            '/web/mall?path=/insurance/order/detail/' +
            orderNo
          break
        case 3:
        case 4: {
          const result = await toolApi.getSchengenOrderIdByOrderNo(orderNo)
          url = getWebURL('visa') + '/booking-detail/' + result.orderId
          break
        }
      }
      window.open(url)
    },
    getTypeName({ productType, serviceType }) {
      let type = ''
      if (productType === 0) {
        type = 0
      } else if (productType === 1 || productType === 3) {
        type = serviceType
      }else if(productType === 5){
        type = serviceType
      }
       else {
        type = productType
      }
      return translateByDict(
        type.toString(),
        mallExpenditureTypeDict,
        'code',
        'name'
      )
    },
  },
}
</script>
